import { render, staticRenderFns } from "./UModal.vue?vue&type=template&id=80724770"
import script from "./UModal.vue?vue&type=script&lang=js"
export * from "./UModal.vue?vue&type=script&lang=js"
import style0 from "./UModal.vue?vue&type=style&index=0&id=80724770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports